import { GridRow, GridRowProps } from '@mui/x-data-grid-pro';

type CustomDataGridRowProps = GridRowProps & {
  onRowContextMenu?: (
    row: GridRowProps['row'],
    event: React.MouseEvent<HTMLDivElement>,
  ) => void;
};

const CustomDataGridRow = (props: CustomDataGridRowProps) => {
  const { onRowContextMenu, ...gridRowProps } = props;

  return (
    <GridRow
      {...gridRowProps}
      data-testid={`row-${props.row.id}`}
      onContextMenu={(event) => {
        onRowContextMenu?.(props.row, event);
      }}
    />
  );
};

export default CustomDataGridRow;
